import Header from "components/headers/light.js";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import styled from "styled-components"; //eslint-disable-line
import tw from "twin.macro";
//import Footer from "components/footers/FiveColumnWithInputForm.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";

const Subheading = tw.span`uppercase tracking-wider text-sm text-gray-800`;
const Text = styled.div`
  ${tw`text-lg  p-10 text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
    }
  }
`;
export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Text>
            <h2>Oto 5 kluczowych powodów, dla których branża detaliczna masowo decyduje się na tę technologię:</h2>
            <h3>1. Natychmiastowa aktualizacja cen w całym sklepie lub sieci sklepów</h3>
            <p>Ceny w sklepach zmieniają się czasem nawet kilka razy dziennie – szczególnie w kategorii warzyw, owoców, mięsa czy nabiału. Dzięki e-cenówkom:
            <ul>
              <li>- aktualizacja trwa kilka sekund,</li>
              <li>- ceny są zmieniane centralnie,</li>
              <li>- ryzyko pomyłek jest praktycznie zerowe.</li>
            </ul>
            Sklep nie musi już angażować pracowników do ręcznego wymieniania etykiet, co przekłada się na oszczędność czasu i redukcję kosztów operacyjnych.</p>
            
            <h3>2. Eliminacja błędów cenowych i reklamacji</h3>
            <p>Papierowe etykiety często powodują niezgodności między ceną na półce a tą w systemie kasowym. E-cenówki rozwiązują ten problem, ponieważ:
            <ul>
              <li>- cena na półce zawsze zgadza się z ceną w systemie,</li>
              <li>- klienci nie zgłaszają już reklamacji,</li>
              <li>- sklep unika strat wynikających z pomyłek.</li>
            </ul>
            To szczególnie ważne w sklepach o dużej rotacji towarów, gdzie błędy cenowe mogą kosztować tysiące złotych miesięcznie.</p>

            <h3>3. Niższe koszty pracy i większa efektywność</h3>
            <p>W branży detalicznej brakuje pracowników, a rotacja jest wysoka. Elektroniczne etykiety cenowe pozwalają:
            <ul>
              <li>- ograniczyć czas poświęcany na zmiany cen o 80–90%,</li>
              <li>- oddelegować pracowników do obsługi klienta i sprzedaży,</li>
              <li>- automatyzować powtarzalne zadania.</li>
            </ul>
            To jedno z najważniejszych usprawnień w codziennej pracy sklepu.</p>

            <h3>4. Lepsze doświadczenie zakupowe i przejrzystość oferty</h3>
            <p>E-cenówki mają wyraźny, czytelny wyświetlacz, który:
            <ul>
              <li>- jest doskonale widoczny z każdej strony,</li>
              <li>- prezentuje cenę, promocję, kod kreskowy, pochodzenie produktu, a nawet oceny klientów,</li>
              <li>- eliminuje „chaos” związany z papierowymi etykietami.</li>
            </ul>
            Nowoczesny wygląd półek zwiększa profesjonalizm sklepu i wpływa na wyższą konwersję zakupową.</p>

            <h3>5. Możliwość wdrażania dynamicznych promocji i inteligentnych akcji cenowych</h3>
            <p>Dzięki elektronicznym etykietom sklepy mogą:
            <ul>
              <li>- prowadzić dynamiczne promocje, np. obniżanie ceny produktów o krótkiej dacie,</li>
              <li>- wprowadzać „happy hours” lub rabaty w określonych godzinach,</li>
              <li>- automatycznie zarządzać promocjami weekendowymi i sezonowymi.</li>
            </ul>
            Umożliwia to pełne wykorzystanie potencjału sprzedażowego i minimalizację strat.</p>
          </Text>
      <MainFeature1
        subheading={<Subheading>Wdrożenia</Subheading>}
        heading="WKRÓTCE"
        description = ""
        // buttonRounded={false}
        // primaryButtonText="Obejrzyj film >>"
        // primaryButtonUrl = "#"
        imageSrc="./supermarket_org.jpg"
        textOnLeft={false}
      />
      {/* <MainFeature1
        // subheading={<Subheading>KROK 2 - wykonanie aplikacji</Subheading>}
        heading=""
        description = ""
        // buttonRounded={false}
        primaryButtonText=""
        primaryButtonUrl = ""
        imageSrc=""
      /> */}
      {/* <MainFeature1
        subheading={<Subheading>KROK 3 - utrzymanie i serwis</Subheading>}
        heading="Jesteśmy tutaj aby pomagać."
        description ="Dokładamy wszelkich starań, aby nasze aplikacje działały bez zarzutu. Jeśli potrzebujesz zaktualizwoać swoje dane lub potrzebujesz porady dotyczącej Twojej eWizytówki skontaktuj się z naszym ekspertem."
        // buttonRounded={false}
        primaryButtonText="Serwis 24/7"
        primaryButtonUrl = "/serwis"
        imageSrc = "./serwis.jpg"
        textOnLeft={false}
      /> */}
      {/* <Features
        subheading={<Subheading>Our Values</Subheading>}
        heading="We follow these."
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        cards={[
          {
            imageSrc: SupportIconImage,
            title: "24/7 Support",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: ShieldIconImage,
            title: "Strong Teams",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
          {
            imageSrc: CustomerLoveIconImage,
            title: "Customer Satisfaction",
            description: "Lorem ipsum donor amet siti ceali placeholder text alipiscing elit sed do eiusmod temport"
          },
        ]}
        linkText=""
      />
      <TeamCardGrid 
        subheading={<Subheading>Our Team</Subheading>}
      /> */}
      <Footer />
    </AnimationRevealPage>
  );
};
